import React from "react";

export default function Header() {
  return (
    <header>
      <nav id="navbar">
        <ul>
          <li>
            <a href="#">home</a>
          </li>
          <li>
            <a href="#">about</a>
          </li>
          <li>
            <a href="#">contact</a>
          </li>
        </ul>
      </nav>
    </header>
  );
}
